import * as React from 'react';
import Button from '@mui/material/Button';
import { Delete, Save, Cancel, EditOutlined, Close, Search, Send } from '@mui/icons-material';
import Stack from '@mui/material/Stack';
import Iconify from '../iconify/Iconify';
import { t } from 'i18next';
import { Typography } from '@mui/material';

export default function ButtonAction({
    disabled = false,
    color,
    fullWidth = false,
    type = 'save',
    size = 'small',
    onClick,
    title,
    variant = 'outlined',
    startIcon,
    sx,
}) {
    return (
        <Stack direction="row">
            {type === 'save' && (
                <Button
                    variant={variant}
                    disabled={disabled}
                    size={size}
                    onClick={onClick}
                    startIcon={<Save />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'send' && (
                <Button
                    variant={variant}
                    disabled={disabled}
                    size={size}
                    onClick={onClick}
                    startIcon={<Send />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'search' && (
                <Button
                    variant={variant}
                    fullWidth={fullWidth}
                    disabled={disabled}
                    size={size}
                    onClick={onClick}
                    startIcon={<Search />}
                    sx={sx}
                >
                    {title}
                </Button>
            )}
            {type === 'cancel' && (
                <Button
                    color={color ? color : 'error'}
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    startIcon={<Cancel />}
                    fullWidth={fullWidth}
                    sx={sx}
                >
                    {title}
                </Button>
            )}
            {type === 'close' && (
                <Button
                    color={color ? color : 'error'}
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    startIcon={<Close />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'delete' && (
                <Button
                    variant={variant}
                    color="error"
                    size={size}
                    onClick={onClick}
                    startIcon={<Delete />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'confirm' && (
                <Button
                    variant={variant}
                    disabled={disabled}
                    color="primary"
                    size={size}
                    fullWidth={fullWidth}
                    onClick={onClick}
                    sx={sx}
                    startIcon={<Iconify icon="material-symbols:check-circle" />}
                >
                    {title}
                </Button>
            )}
            {type === 'update' && (
                <Button
                    sx={sx}
                    variant={variant}
                    color={color || 'primary'}
                    size={size}
                    onClick={onClick}
                    startIcon={<EditOutlined />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}{' '}
            {type === 'get' && (
                <Button
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    fullWidth={fullWidth}
                    startIcon={<Iconify icon="material-symbols:add-shopping-cart-outline-rounded" />}
                >
                    <Typography
                        sx={{ fontSize: { xs: '12px', md: '15px' }, fontWeight: '600', maxWidth: '100%' }}
                        noWrap
                    >
                        {title}
                    </Typography>
                </Button>
            )}
            {type === 'export' && (
                <Button
                    variant={variant}
                    disabled={disabled}
                    size={size}
                    onClick={onClick}
                    startIcon={<Iconify icon="material-symbols:backup-rounded" />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'import' && (
                <Button
                    variant={variant}
                    disabled={disabled}
                    size={size}
                    onClick={onClick}
                    startIcon={<Iconify icon="material-symbols:cloud-download-rounded" />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'change' && (
                <Button
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    startIcon={<Iconify icon="material-symbols:lock-reset" />}
                    fullWidth={fullWidth}
                >
                    {t('change_password')}
                </Button>
            )}
            {type === 'add' && (
                <Button
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    startIcon={<Iconify icon="material-symbols:add-circle-outline" />}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
            {type === 'other' && (
                <Button
                    variant={variant}
                    size={size}
                    disabled={disabled}
                    onClick={onClick}
                    startIcon={startIcon}
                    color={color}
                    fullWidth={fullWidth}
                >
                    {title}
                </Button>
            )}
        </Stack>
    );
}
